import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState, TVehicleLiveCamerasData } from "../../api/store/commonSlice";
import { useTranslation } from "react-i18next";
import { LegacyRef, useEffect, useRef, useState } from "react";
import svgIcons from "../../assets/svg/svgIcons";

const ModalVehicleLiveCameras = () => {
  const { t: tMain } = useTranslation();

  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const vehicleLiveCamerasData: TVehicleLiveCamerasData = useSelector(
    (state: any) => state.commonReducer.vehicleLiveCamerasData
  );
  const dispatch = useDispatch();

  const [cameraOnDisplay, setCameraOnDisplay] = useState<number | null>(null);
  useEffect(() => {
    setCameraOnDisplay(
      vehicleLiveCamerasData?.cameras.length > 0
        ? vehicleLiveCamerasData?.cameras[0]
        : null
    );
  }, [vehicleLiveCamerasData]);

  const playerRef = useRef<HTMLElement>()
  useEffect(() => {
    const element = playerRef.current
    const onCloseHandler = (event: Event) => {
      console.log('onCloseHandler', event)
      hideModal()
    }
    const onComponentErrorHandler = (event: Event) => {
      console.log('onComponentErrorHandler', event)
    }
    if (element) {
      element.addEventListener("close", onCloseHandler)
      element.addEventListener("componentError", onComponentErrorHandler)
    }
    return () => {
      if (element) {
        element.removeEventListener("close", onCloseHandler)
        element.removeEventListener("componentError", onComponentErrorHandler)
      }
    }
  }, [playerRef])

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showVehicleLiveCameras: false }));
  };

  if (modalsState.showVehicleLiveCameras === false) return null;

  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      />
      <div
        className={
          "fixed inset-y-1/2 inset-x-1/2 w-[calc(100vw-6rem)] h-[calc(100vh-6rem)] bg-black/80 overflow-hidden " +
          "Xbg-white rounded-xl shadow-lg z-modal"}
        style={{ transform: 'translate(-50%, -50%)' }}
      >

        {/* Camera Buttons Area */}
        <div className="absolute top-4 right-4 flex flex-row gap-2 z-50 p-2 bg-white/20 rounded-full">
          {vehicleLiveCamerasData?.cameras.map((cameraId) => (
            <button
              key={cameraId}
              className={
                "size-10 flex items-center justify-center rounded-full focus:ring focus:ring-white outline-0 " +
                (cameraOnDisplay === cameraId ? "bg-field-success text-white" : "bg-white/50 hover:bg-white")
              }
              onClick={() => setCameraOnDisplay(cameraId)}
            >
              {cameraId}
            </button>
          ))}
          {vehicleLiveCamerasData?.cameras.length > 0 && (
            <div className="w-px h-10 bg-white/15" />
          )}
          <button
            className="size-10 flex items-center justify-center rounded-full bg-black hover:bg-gray-600 focus:ring focus:ring-white outline-0"
            onClick={hideModal}
          >
            <img src={svgIcons.CloseIcon} alt="Close" className="grayscale-0 brightness-0 invert opacity-50" />
          </button>
        </div>

        {/* Live Camera Component */}
        {!!cameraOnDisplay ? (
          <lytx-live-video
            style={{ zIndex: 10 }}
            ref={playerRef as LegacyRef<HTMLElement>}
            auth-token={vehicleLiveCamerasData?.authToken || ''}
            imei={vehicleLiveCamerasData?.imei || ''}
            camera-id={cameraOnDisplay?.toString() || ''}
            organization-id={vehicleLiveCamerasData?.organizationId || ''}
            close-player={false}
          />
        ) : (
          <div className="flex items-center justify-center h-full bg-gray-800 rounded-lg">
            <p className="text-2xl text-gray-300">{tMain('mapFleet.details.recorder_no_cameras')}</p>
          </div>
        )}
      </div>
    </>
  );
}

export default ModalVehicleLiveCameras;
